module.exports = __webpack_public_path__ + "img/icon-support.fadaebc3.svg";